import React from "react";
import {useSelector} from "react-redux";
import styled from "styled-components";
import {Headline} from "./Headline";
import {FailedOutcomes} from "./FailedOutcomes";
import {SuccessfulOutcomes} from "./SuccessfulOutcomes";
import {classifyUpdateOutcomes} from "./classifyUpdateOutcome";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const OutcomesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    max-height: 280px;
    overflow-y: auto;
    overflow-x: hidden;
`;

const DividingLine = styled.div`
    margin-top: 12px;
    margin-bottom: 12px;
    height: 2px;
    border-bottom: 0.5px solid #4a4a4a;
`;

const UpdateOutcome = ({}) => {
    const {imeUserId, outcomes, requestedPercentage, recommendation} = useSelector(
        ({ideaDetails: {updating: {outcomes, requestedPercentage}, data: {recommendation}}, userIdentity: {imeUserId}}) => ({outcomes, requestedPercentage, recommendation, imeUserId})
    );

    const classifiedIdeaOutcome = classifyUpdateOutcomes(outcomes, requestedPercentage);

    const succeeded = classifiedIdeaOutcome.portfolios.filter(p => p.status === "success");
    const partiallyUpdated = classifiedIdeaOutcome.portfolios.filter(p => p.status === "partial");
    const failed = classifiedIdeaOutcome.portfolios.filter(p => p.status === "failed");

    return (
        <Container className="t-update-outcome">
            <Headline status={classifiedIdeaOutcome.status} recommendation={recommendation} />
            <OutcomesContainer>
                <FailedOutcomes className="t-failed-outcomes" failed={failed} severity="failed"/>
                { (failed.length > 0 && (succeeded.length > 0 || partiallyUpdated.length > 0)) ? <DividingLine/> : null }
                <FailedOutcomes className="t-partial-outcomes" failed={partiallyUpdated} severity="partial"/>
                { (partiallyUpdated.length > 0 && succeeded.length > 0) ? <DividingLine/> : null }
                <SuccessfulOutcomes className="t-successful-outcomes" succeed={succeeded} requestedPercentage={requestedPercentage}/>
            </OutcomesContainer>
        </Container>
    );
};

export default UpdateOutcome;
